import {Component, OnChanges, OnDestroy, OnInit} from '@angular/core';
import {PageHeaderConfig} from "../../../../../../core/shared/service/page/page-header-config.interface";
import {ActivatedRoute, Router} from "@angular/router";
import {CmContractObjectViewTypeUiEnum} from "./data/cm-contract-object-view-type-ui.enum";
// import {OverlayPanel} from "primeng/overlaypanel";
import {
    ObjectPageComponent
} from "../../../../../../core/shared/object/mvs-object-page-component/object-page.component";
import {FilterCriteria} from "../../../../../../core/shared/filter/api/filter.criteria";
import {ObjectRequestList} from "../../../../../../core/shared/dto/object/request/object-request-list";
import {TopbarService} from "../../../../../../core/shared/service/topbar/topbar.service";
import {MvsObjectNavigationService} from "../../../../../../core/shared/navigation/mvs-object-navigation.service";
import {MvsCoreService} from "../../../../../../core/shared/service/mvs-core.service";
import {IndicatorButton} from "../../../../../../core/shared/indicator/data/indicator-button";
import {ObjectRequestComplex} from "../../../../../../core/shared/dto/object/request/object-request-complex";
import {ObjectRequestComplexNode} from "../../../../../../core/shared/dto/object/request/object-request-complex-node";
import {ObjectRequestRelation} from "../../../../../../core/shared/dto/object/request/object-request-relation";
import {DtoList} from "../../../../../../core/shared/dto/dto.list";
import {MvsObjectNavigationEntry} from "../../../../../../core/shared/navigation/mvs-object-navigation-entry";
import {
    MvsObjectNavigationActionEnum
} from "../../../../../../core/shared/navigation/mvs-object-navigation-action-enum";
import {ContractDto} from "../../../../model/dto/entity/contract.dto";
import {ContractFormerHistoryNodeDto} from "../../../../model/dto/entity/contract-former-history-node.dto";
import {ContractService} from "../../../../service/api/contract.service";
import {Popover} from "primeng/popover";
import {CmContractSuccessionState} from '../../../../logic/contract-succession/cm-contract-succession-state';
import {
    CmContractNeverActive,
    CmSuccessionConnectorKind
} from '../../../../logic/contract-never-active/cm-contract-never-active';

export interface UiContractToFormerMapping {
  contractId: number,
  formerContractId: number,
  formerContractDto: ContractDto
}
@Component({
    selector: 'mvs-cm-contract-consultant-page',
    templateUrl: './cm-contract-consultant.page.html',
    styleUrls: ['cm-contract-consultant.page.scss'],
    standalone: false
})
export class CmContractConsultantPage
  extends ObjectPageComponent
  implements OnInit, OnDestroy, OnChanges {

  override defaultLabel: string = "Vertragsansicht";
  viewType: CmContractObjectViewTypeUiEnum = CmContractObjectViewTypeUiEnum.standard;
  contractDto: ContractDto;
  ticketIndicatorFilterCriteria: FilterCriteria[];
  workflowIndicatorFilterCriteria: FilterCriteria[];
  workflowIndicatorObjectRequest: ObjectRequestList;
  formerContractMapping: UiContractToFormerMapping[];
  showMoreFormerButton: boolean = false;
  showFormerContract: boolean;
  contractFormerHistoryNodeDto: ContractFormerHistoryNodeDto;
  displaySidebar: boolean = false;

  /**
   * Predecessor AND successor tree (Zukunftsverträge) of the shown contract, loaded with ONE request
   * right after the contract itself ({@link #getContractDto}). Both „…" open from this preloaded data:
   * the left one shows {@code successorHistory}, the right one {@code formerHistory}
   * ({@link #openFormerHistory}). The load, switch and failure rules live in the state class (shared with
   * {@code CmContractPage}); this page MUST call {@code destroy()} in {@link #ngOnDestroy}.
   */
  readonly succession = new CmContractSuccessionState();

  /** True while the successor popover („Zukunftsverträge") is open - renders its org chart lazily. */
  showSuccessorContract: boolean;

  /**
   * The „Nie aktiv“ rule (Nachtrag 24.10.2026, WR1/WR2/WR6), exposed to the template: {@code marker(dto)}
   * labels the successor, the predecessor and the current contract, and {@code marker} itself is bound to
   * the {@code neverActiveMarker} input of BOTH org-chart popovers (decision F7). The rule lives in
   * cm/logic, the page only places the result (spec 02-nachtrag-widerruf §6.2/§7).
   */
  readonly neverActive = CmContractNeverActive;

  /**
   * Kind of the LEFT connector (WR6, S-17): older = the shown contract, newer = the inline successor
   * ({@link CmContractSuccessionState#successorContract}, which already applies WR3/S-15).
   */
  get successorConnectorKind(): CmSuccessionConnectorKind {
    return CmContractNeverActive.connectorKind(this.contractDto, this.succession.successorContract);
  }

  /**
   * Kind of the RIGHT connector (WR6, S-17): older = the inline predecessor (the FK predecessor, D9),
   * newer = the shown contract.
   */
  get formerConnectorKind(): CmSuccessionConnectorKind {
    return CmContractNeverActive.connectorKind(this.contractDto?.formerContractDto, this.contractDto);
  }

  constructor(
    protected router: Router,
    protected override route: ActivatedRoute,
    protected topBarService: TopbarService,
    protected contractService: ContractService,
    protected navigationService: MvsObjectNavigationService,
    protected override coreService: MvsCoreService) {

    super(route, coreService);
  }

  override ngOnInit() {
    super.ngOnInit();
  }

  override ngOnDestroy(): void {
    // cancels an in-flight succession request - it must not outlive the page
    this.succession.destroy();
    super.ngOnDestroy();
  }

  protected override getObjectType(): string {
    return "cm.Contract";
  }

  protected override onRouteChangeBefore(params: any) {

    if (params["view"]) {
      this.viewType = <CmContractObjectViewTypeUiEnum>+params["view"];
    }

  }


  override isBreadcrumbVisible(): boolean {
    return false;
  }

  override refreshComponent() {
    this.getContractDto();
  }

  setIndicators() {
    this.setCoreIndicators();
  }


  setCoreIndicators() {
    const ticketIndicator = new IndicatorButton('tm.Ticket', 'Tickets', this.ticketIndicatorFilterCriteria, 'top-right', null);
    const workFlowIndicator = new IndicatorButton('wf.WfProcess', 'Workflows', this.workflowIndicatorFilterCriteria, 'top-right', this.workflowIndicatorObjectRequest);

    const buttons: IndicatorButton[] = [];
    buttons.push(ticketIndicator);
    buttons.push(workFlowIndicator);

    this.topBarService.setButtons(buttons);

  }

  getContractDto() {

    const dtoRequest: ObjectRequestList = new ObjectRequestList(
      false,
      [FilterCriteria.create('id', FilterCriteria.cOperatorEqual, this.objectIdentifier.objectId)],
      []);

    /*
     * The two contractTerminationType nodes (root + under formerContract) deliver
     * contractTerminationTypeDto.name, the Stornotyp of the „Nie aktiv“ tag: this generic list does not
     * resolve DTO texts, so contractTerminationTypeDtoName never arrives here (spec 02 N2/§7). These are
     * the same two contractTerminationType nodes as ContractService.getContractHeaderRequestComplex() of
     * the main page; the rest of this inline request stays as it was (no customerType under
     * joinCurrentMainCustomer).
     */
    dtoRequest.objectRequestComplex = ObjectRequestComplex.build(
      false,
      false,
      ObjectRequestComplexNode.createSimpleAttributeNode('contractType'),
      ObjectRequestComplexNode.createSimpleAttributeNode("partner"),
      ObjectRequestComplexNode.createSimpleAttributeNode("formerContract").addNodes(
        ObjectRequestComplexNode.createSimpleAttributeNode("partner"),
        ObjectRequestComplexNode.createSimpleAttributeNode("contractTerminationType")
      ),
      ObjectRequestComplexNode.createSimpleAttributeNode("contractTerminationType"),
      ObjectRequestComplexNode.createRelationNode(
        "joinCurrentMainCustomer", ObjectRequestRelation.createJoin("+currentMainCustomer")
      ).addNodes(ObjectRequestComplexNode.createRelationNode("personDto", ObjectRequestRelation.createJoin("person")))
    );

    this.contractService.list(dtoRequest).subscribe((res: DtoList<ContractDto>) => {
      this.contractDto = res?.entries?.[0];

      // F8: an empty result used to throw on the next line. Nothing else of this callback applies to it.
      if (!this.contractDto) {
        this.succession.reset();
        return;
      }

      /*
       * Succession (predecessor + successor tree) in ONE request, started only AFTER the contract is
       * here: it never blocks the header, and a missing contract raises no second error. A different id
       * clears the previous contract's trees at once, the same id keeps them until the reply replaces them.
       */
      this.succession.load(this.contractService, this.contractDto.id);

      if (this.contractDto?.formerContractDto) {
        this.formerContractMapping = [];
        this.formerContractMapping.push({
          contractId: this.objectIdentifier.objectId,
          formerContractId: this.contractDto.formerContractDto.id,
          formerContractDto: this.contractDto.formerContractDto
        });
        this.showMoreFormerButton = true;
      } else {
        // F8: without this the previous contract's predecessor and right „…" stayed after a switch
        this.formerContractMapping = null;
        this.showMoreFormerButton = false;
      }

      this.setIndicators();

      let lastName, statusName = '';

      if (this.contractDto.contractTypeDto) {
        statusName = this.contractDto.contractTypeDto.name;
      }

      if (this.contractDto.joinCurrentMainCustomer) {
        lastName = this.contractDto.joinCurrentMainCustomer.personDto.lastName;
      }

      //rename tab name
      const tabName = `${lastName} - ${statusName}`;
      this.renameTab(tabName);

      this.initialized = true;

      // Re-trigger page header now that objectIdentifier and contractDto are available
      this.setActivePage();
    }, () => {
      // the global HTTP error toast reports the failure; no succession for a contract that did not load
      this.succession.reset();
    });
  }

  handleIdSelect(id: number) {
    this.objectIdentifier.objectId = id;
    this.objectIdentifier = this.objectIdentifier.clone();
    this.refreshComponent();
  }

  handleNavigateToPartner(partnerId: number) {
    if (!partnerId) {
      return;
    }

    const object = MvsObjectNavigationEntry.createNavigationEntry('cm.Partner', partnerId, null, null, null, null, MvsObjectNavigationActionEnum.any, 'full');
    this.navigationService.navigateTo(object, 'right');

    // this.navigationService.openObjectInNewTab(object);

  }

  /**
   * Opens the former contract (Vorvertrag) in a new browser tab - the same route the contract-history
   * popover („…", `former-contract-mapping`) uses. Bound to the former contract's VSN chip in the
   * sub-header; the current contract's own VSN stays non-clickable.
   *
   * A missing id (the mapping holds no former contract DTO) does nothing.
   *
   * @param contractId id of the former contract
   * @ticket TM-1000002018
   */
  handleNavigateToFormerContract(contractId: number) {
    this.openContractInNewTab(contractId);
  }

  createTicket() {
    const mvsObjectNavigationEntry = MvsObjectNavigationEntry.createNavigationEntry("tm.Ticket", 0, "Ticket", null, null, null, MvsObjectNavigationActionEnum.create, 'full',null,'consultant');
    this.navigationService.navigateTo(mvsObjectNavigationEntry, 'right');
  }

  /**
   * Opens the successor contract (Zukunftsvertrag) in a new browser tab - same route as
   * {@link #handleNavigateToFormerContract}. Bound to the successor's VSN chip left of the current
   * contract (click + Enter).
   *
   * A missing id (null, undefined, 0) does nothing.
   *
   * @param contractId id of the successor contract
   */
  handleNavigateToSuccessorContract(contractId: number) {
    this.openContractInNewTab(contractId);
  }

  /**
   * The right „…": opens the predecessor tree from the preloaded succession data - no request of its
   * own ({@code getFormerContractHistory} is no longer called by this page). WHEN it may open (loaded /
   * loading / retry, D9) is decided by {@link CmContractSuccessionState#requestFormerHistory}; this page
   * only decides HOW.
   *
   * The button is read from {@code event.currentTarget} SYNCHRONOUSLY: once the click has been
   * dispatched {@code currentTarget} is null, and PrimeNG's popover would then align to
   * {@code event.target} (possibly the icon inside the button) or nothing. While the click is still
   * being dispatched (tree already loaded) the popover is toggled exactly like a plain popover button.
   */
  openFormerHistory(event: Event, op: Popover): void {
    const button = event?.currentTarget;
    this.succession.requestFormerHistory(this.contractService, this.contractDto?.id, () => {
      this.showFormerHistory();
      if (event?.currentTarget) {
        op.toggle(event);
      } else {
        op.toggle(event, button);
      }
    });
  }

  /**
   * The left „…": opens the successor tree (Zukunftsverträge) from the preloaded succession data.
   * The button only exists while a successor is known, so the data is always there.
   */
  openSuccessorHistory(event: Event, op: Popover): void {
    if (!this.succession.hasSuccessor) {
      return;
    }
    this.showSuccessorContract = true;
    op.toggle(event);
  }

  /** Hands the preloaded predecessor tree to the (unchanged) predecessor popover binding. */
  private showFormerHistory(): void {
    this.contractFormerHistoryNodeDto = this.succession.formerHistory;
    this.showFormerContract = true;
  }

  /**
   * Opens a contract in a new browser tab - the route of both VSN links (predecessor and successor).
   * A missing id (null, undefined, 0) does nothing.
   */
  private openContractInNewTab(contractId: number): void {
    if (!contractId) {
      return;
    }
    const object = MvsObjectNavigationEntry.createNavigationEntry(
      'cm.Contract', contractId, null, null, null, null, MvsObjectNavigationActionEnum.any, 'full');
    this.navigationService.openObjectInNewTab(object);
  }


  // TM-1000001554: Do NOT return a header config here. The contract header is
  // rendered inline in this page's template (see cm-contract-consultant.page.html).
  // Returning a header config would cause the shared <mvs-page-header> in the
  // shell-consultant layout to render the header in a slot OUTSIDE the
  // object-navigation overlay, producing the wrong order (tabs above header)
  // whenever the page is opened inside an overlay.
  getPageHeaderConfig(): PageHeaderConfig {
    return null;
  }

  openSidebar(){
    this.displaySidebar = true;
  }

  /**
   * Check if the given value is an image URL or a Font Awesome/icon class.
   * @param value The image field value from backend
   * @returns true if it's an image URL, false if it's an icon class
   */
  isImageUrl(value: string): boolean {
    if (!value) {
      return false;
    }
    // Image URLs typically start with http, https, /, or data: (base64)
    return value.startsWith('http://') ||
        value.startsWith('https://') ||
        value.startsWith('/') ||
        value.startsWith('data:');
  }

}
